import { cx } from 'class-variance-authority'

export const NumberBadge = ({ count }: { count: number }) => (
  <span
    className={cx(
      'absolute -bottom-0.5 right-0 z-20 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white ring-1 ring-white',
      !count && 'hidden',
      count >= 100 && '-right-1',
    )}
  >
    {count}
  </span>
)
